import type { ExamRequestFailure } from '@/utils/network/examRequest';

export interface DraftSaveHealth {
  recordId: number;
  failures: number;
  lastFailure?: ExamRequestFailure;
}

export function createDraftSaveHealth(recordId = 0): DraftSaveHealth {
  return {recordId, failures: 0};
}

export function recordDraftSaveFailure(health: DraftSaveHealth, failure: ExamRequestFailure): void {
  // Page cancellation and a skipped duplicate save are not connectivity failures.
  if (failure.reason === 'aborted' || failure.reason === 'busy') return;
  health.failures += 1;
  health.lastFailure = failure;
}
